import { render } from "./UEResearchListView.vue?vue&type=template&id=255b0653&scoped=true"
import script from "./UEResearchListView.vue?vue&type=script&lang=js"
export * from "./UEResearchListView.vue?vue&type=script&lang=js"

import "./UEResearchListView.vue?vue&type=style&index=0&id=255b0653&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255b0653"]])

export default __exports__